import React, { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import classNames from 'classnames';

import css from './style.module.scss';

interface IProps {
  children: ReactNode;
  to?: string;
  tag?: string;
  textDecoration?: 'none';
  fontSize?: '12';
  className?: string;
  [restProps: string]: any;
  onClick?: () => void;
}

const LinkComponent: FC<IProps> = ({
  children,
  to,
  tag,
  textDecoration,
  fontSize,
  className,
  onClick,
  ...restProps
}) => {
  if (tag) {
    return React.createElement(
      tag,
      {
        className: classNames(
          css.link,
          {
            [css[`link_textDecoration_${textDecoration}`]]: textDecoration,
            [css[`link_fontSize_${fontSize}`]]: fontSize,
            [css[`link_tag_${tag}`]]: tag,
          },
          className,
        ),
        ...restProps,
      },
      children,
    );
  }

  return (
    <Link
      to={to || ''}
      onClick={onClick}
      className={classNames(
        css.link,
        {
          [css[`link_textDecoration_${textDecoration}`]]: textDecoration,
        },
        className,
      )}
    >
      {children}
    </Link>
  );
};

export default LinkComponent;
